import {
  useConsId,
  useLogInteraction,
  useUpdateInteraction,
} from '@frx/frx-react-context';
import { useCallback, useMemo } from 'react';
import { Interaction } from '@frx/frx-services';
import { useEventId } from '../use-eventId';

type FCInteractionProp = {
  cons_id: string;
  interaction_type_id: number;
  interaction_subject: string;
};

export const useApiParams = ({
  id,
  subject,
}: {
  id: string;
  subject: string;
}) => {
  const frId = useEventId();
  const consId = useConsId();
  const { mutate: updateInteraction } = useUpdateInteraction();
  const { mutate: createInteraction } = useLogInteraction();

  const handleUpdateInteraction = useCallback(
    (interaction: Interaction) =>
      updateInteraction({
        interaction_id: interaction?.interactionId,
        interaction_type_id: interaction?.interactionTypeId,
      }),
    [updateInteraction]
  );

  const handleLogInteraction = useCallback(
    (interaction: FCInteractionProp) =>
      createInteraction({
        ...interaction,
      }),
    [createInteraction]
  );

  const ctx = useMemo(
    () => ({
      cons_id: String(consId),
      interaction_subject: `${subject}_${frId}`,
      interaction_type_id: Number(id),
    }),
    [consId, frId, id, subject]
  );

  return { ctx, handleUpdateInteraction, handleLogInteraction };
};
